module.exports = __webpack_public_path__ + "img/INF-B-1-III.46b7304f.png";